import { Div, Collection, RefString, Button } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { Tab } from "../../../Models/Product/Tab";
import { Tabs } from "./Tabs";
import { TabsSwitcher } from "./TabsSwitcher";
import { DotButtons } from "./DotButtons";


export class TabbedDescriptionPrinter extends Div
{
    constructor(tabs: Collection<Tab>, collection: Collection<Field>)
    {
        super("product-info__container");

        const visibleTabs = new Collection(tabs.Filter(x => x.IsVisible.value));

        const firstNonEmptyTab = visibleTabs.Items.find(x => x.Label.value != "")?.Label?.value || "";

        const selectedTab = new RefString(firstNonEmptyTab); // NIE ROBIĆ TEGO Storable!

        this.Append(
            new Div("card product-info__card").Append(
                new Div("card__content product-info__content").Append(
                    new Div("product-info__tabs").Append(
                        visibleTabs.Count > 0 && new Tabs(visibleTabs, selectedTab),
                        new TabsSwitcher(visibleTabs, collection, selectedTab),
                        new DotButtons(visibleTabs, selectedTab),
                        new Button("Czytaj dalej...").Class("product__button product__button--compact").MarginTop(12)
                            .OnClick(() =>
                            {
                                const currentTabIndex = visibleTabs.Items.findIndex(x => x.Label.value == selectedTab.value);
                                const nextTab = visibleTabs.Items[currentTabIndex + 1];
                                if (nextTab)
                                {
                                    selectedTab.value = nextTab.Label.value;
                                }
                            })
                            .VisibleWhen(selectedTab, v =>
                            {
                                const currentTabIndex = visibleTabs.Items.findIndex(x => x.Label.value == selectedTab.value);
                                return currentTabIndex < visibleTabs.Items.length - 1;
                            })
                    )
                )
            )
        );
    }
}
